(function () {
  'use strict';

  var configEl = document.querySelector('script[id^="mahj-mockup-config-"]');
  if (!configEl) return;

  var config = JSON.parse(configEl.textContent);
  var sectionId = config.sectionId;
  var supportedColors = config.supportedColors || [];
  var fieldInputIds = config.fieldInputIds || {};

  // Elements
  var triggerBtn = document.getElementById('MockupTrigger-' + sectionId);
  var modal = document.getElementById('MockupPreviewModal-' + sectionId);
  if (!triggerBtn || !modal) return;

  var triggerWrap = triggerBtn.closest('.mahj-mockup-trigger-wrap');
  var stateEls = modal.querySelectorAll('[data-mockup-loading], [data-mockup-error], [data-mockup-gallery]');
  var loadingEl = modal.querySelector('[data-mockup-loading]');
  var errorEl = modal.querySelector('[data-mockup-error]');
  var galleryEl = modal.querySelector('[data-mockup-gallery]');
  var frontImg = modal.querySelector('[data-mockup-front]');
  var sideImg = modal.querySelector('[data-mockup-side]');

  var LABEL_DEFAULT = config.buttonLabel || 'See it on the shirt';
  var LABEL_CACHED = 'View preview';

  // Track current color (exact Shopify option value, lowercased)
  var currentColor = String(config.currentColorOption || '').toLowerCase();
  var currentColorVariant = resolveColorFromOption(currentColor);

  function resolveColorFromOption(colorName) {
    var key = String(colorName || '').toLowerCase();
    return config.colorOptionMap[key] || config.colorOptionMap['_default'] || 'dark';
  }

  // Collect field values from all configured inputs
  function collectFields() {
    var fields = {};
    var keys = Object.keys(fieldInputIds);
    for (var i = 0; i < keys.length; i++) {
      var fieldName = keys[i];
      var inputId = fieldInputIds[fieldName];
      var input = document.getElementById(inputId);
      if (input && input.value.trim()) {
        fields[fieldName] = input.value.trim();
      }
    }
    return fields;
  }

  // Check if at least one required field has a value
  function hasRequiredFields() {
    var fields = collectFields();
    return Object.keys(fields).length > 0;
  }

  // Focus first empty field
  function focusFirstEmptyField() {
    var keys = Object.keys(fieldInputIds);
    for (var i = 0; i < keys.length; i++) {
      var input = document.getElementById(fieldInputIds[keys[i]]);
      if (input && !input.value.trim()) {
        input.focus();
        return;
      }
    }
  }

  // In-memory session cache (lost on page reload)
  var cache = null;

  function invalidateCache() {
    cache = null;
    setButtonLabel(LABEL_DEFAULT);
    var mockupInput = document.getElementById('MockupFrontUrl-' + sectionId);
    if (mockupInput) mockupInput.value = '';
  }

  function setButtonLabel(text) {
    var iconSpan = triggerBtn.querySelector('.mahj-mockup-trigger__icon');
    if (iconSpan && iconSpan.nextSibling) {
      iconSpan.nextSibling.textContent = text;
    }
  }

  // Color gating — show/hide button based on exact color match
  function updateButtonVisibility() {
    if (!triggerWrap) return;
    var isSupported = supportedColors.indexOf(currentColor) !== -1;
    triggerWrap.style.display = isSupported ? '' : 'none';
  }

  updateButtonVisibility();

  // Listen for variant changes
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
      var variant = event && event.data && event.data.variant;
      if (variant && variant.option1) {
        currentColor = String(variant.option1).toLowerCase();
        currentColorVariant = resolveColorFromOption(currentColor);
        invalidateCache();
        updateButtonVisibility();
      }
    });
  }

  // Listen for personalization input changes on ALL field inputs
  var inputKeys = Object.keys(fieldInputIds);
  for (var i = 0; i < inputKeys.length; i++) {
    var input = document.getElementById(fieldInputIds[inputKeys[i]]);
    if (input) {
      input.addEventListener('input', function () {
        invalidateCache();
      });
    }
  }

  // Build cache key from fields + color
  function cacheKey(fields, colorVariant) {
    return JSON.stringify(fields) + '|' + colorVariant;
  }

  triggerBtn.addEventListener('click', function () {
    if (!hasRequiredFields()) {
      focusFirstEmptyField();
      return;
    }

    var fields = collectFields();
    var key = cacheKey(fields, currentColorVariant);

    // Check cache
    if (cache && cache.key === key) {
      frontImg.src = cache.frontImageUrl;
      sideImg.src = cache.sideImageUrl || '';
      sideImg.closest('.mahj-mockup-modal__image-wrap').style.display = cache.sideImageUrl ? '' : 'none';
      showState('gallery');
      modal.show(triggerBtn);
      return;
    }

    // Reset and show loading
    frontImg.src = '';
    sideImg.src = '';
    showState('loading');
    modal.show(triggerBtn);

    fetch(config.workerUrl + '/preview/mockup', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shopifyProductId: String(config.shopifyProductId),
        fields: fields,
        colorVariant: currentColorVariant,
        garmentColor: currentColor
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (data) {
        if (!data.frontImageUrl) throw new Error('No mockup URL returned');

        cache = {
          key: key,
          frontImageUrl: data.frontImageUrl,
          sideImageUrl: data.sideImageUrl || null
        };

        frontImg.src = data.frontImageUrl;
        sideImg.src = data.sideImageUrl || '';
        sideImg.closest('.mahj-mockup-modal__image-wrap').style.display = data.sideImageUrl ? '' : 'none';
        showState('gallery');
        setButtonLabel(LABEL_CACHED);

        var mockupInput = document.getElementById('MockupFrontUrl-' + sectionId);
        if (mockupInput) mockupInput.value = data.frontImageUrl;
      })
      .catch(function () {
        showState('error');
        setButtonLabel(LABEL_DEFAULT);
      });
  });

  // State management
  function showState(state) {
    for (var i = 0; i < stateEls.length; i++) {
      stateEls[i].classList.remove('is-active');
    }
    if (state === 'loading') loadingEl.classList.add('is-active');
    else if (state === 'error') errorEl.classList.add('is-active');
    else if (state === 'gallery') galleryEl.classList.add('is-active');
  }
})();
